import Table from '../../modules/tableElements/table';

export interface ProductList {
  mn: string;
  md: string;
  sn: string;
  sfver: string;
  type: string;
}

export interface TableCommandResponse {
  products?: ProductList[];
}

const commandTable = ({ products }: TableCommandResponse) => {
  if (!products?.length) {
    return null;
  }

  const friendlyNames = {
    mn: 'Manufacturer',
    md: 'Model',
    sn: 'Serial Number',
    sfver: 'Firmware Version',
    type: 'Type',
  };

  const columns = Object.keys(products[0]).map((key) => ({
    id: key,
    label: friendlyNames[key.toLowerCase()] || key,
  }));

  return (
    <Table
      columns={columns}
      data={products}
      emptyStateMessage="No data"
      isLoading={false}
      pageNumber={1}
      perPage={products.length}
      total={products.length}
      handleChangePage={() => {}}
      equalColumns
      hidePagination
    />
  );
};

export default commandTable;
